<h2 mat-dialog-title>Tag this review</h2>


<mat-dialog-content class="flex flex-col gap-4 w-full">

  @if (errorMessage) {
    <div class="text-sm text-red-600">{{ errorMessage }}</div>
  }


  <mat-form-field appearance="outline" class="flex-1 w-full">
    <mat-label >Tags</mat-label>
    <mat-select
      class="w-full"
      [formField]="updateForm.labelIds"
      multiple>
      @for (label of labels; track label.id ?? $index) {
        @if (label.id !== undefined) {
          <mat-option [value]="label.id" >
            {{ label.name }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>

  @if (loadingTagForm()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="save()"
  >
    Save
  </button>

  <button  mat-stroked-button type="button" (click)="close()">
    Cancel
  </button>
</mat-dialog-actions>
